<template>
  <v-dialog :value="value" max-width="440" persistent @input="$emit('input', $event)">
    <v-card class="kf-confirm">
      <v-card-title class="kf-confirm__title">
        <LucideIcon :name="icon" :color="accent" class="mr-2" :size="22" />
        {{ title }}
      </v-card-title>

      <v-card-text class="kf-confirm__body">
        <slot>{{ message }}</slot>
      </v-card-text>

      <v-card-actions class="kf-confirm__actions">
        <v-spacer />
        <v-btn
          v-if="!hideCancel"
          text
          small
          class="text-none"
          :disabled="loading"
          @click="$emit('cancel')"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          :color="accent"
          depressed
          small
          dark
          class="text-none"
          :loading="loading"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "KfConfirmDialog",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: "Are you sure?" },
    message: { type: String, default: "" },
    confirmText: { type: String, default: "Confirm" },
    cancelText: { type: String, default: "Cancel" },
    /** "danger" flips the accent to red for destructive actions. */
    tone: { type: String, default: "primary" },
    icon: { type: String, default: "circle-help" },
    loading: { type: Boolean, default: false },
    /**
     * Drop the Cancel button, leaving one action.
     *
     * For a dialog that only tells you something -- there is nothing to cancel
     * when the alternative is "carry on reading". Opt-in, so the two callers
     * that genuinely ask a question keep both buttons.
     */
    hideCancel: { type: Boolean, default: false },
  },
  computed: {
    accent() {
      return this.tone === "danger" ? "error" : "primary";
    },
  },
};
</script>

<style scoped>
.kf-confirm__title {
  font-size: 17px;
  font-weight: 700;
  color: var(--kf-brand);
  padding-bottom: 6px;
  word-break: normal;
}
.kf-confirm__body {
  font-size: var(--kf-fs-body);
  color: #000;
  line-height: 1.55;
  padding-bottom: 4px;
}
.kf-confirm__actions {
  padding: 8px 16px 14px;
}
</style>
